import { useSelector } from 'react-redux';

import { IAppState } from '../../common/state';
import { ECoworkingOfferType } from '../../json_query';

export function useCoworkingOfferTypeSelector() {
  return useSelector<IAppState, ECoworkingOfferType[] | undefined>(
    state => state.filters.jsonQuery.coworking_offer_type?.value,
  );
}
